import { createTheme, TypeBackground } from '@mui/material/styles';

declare module '@mui/material/styles' {
  export interface SAPop {
    light?: string;
    main: string;
    dark?: string;
    contrastText: string;
  }

  export interface SABackground extends Partial<TypeBackground> {
    strip: string;
  }
}

export enum Color {
  black = 'black',
  blue = '#1e90ff',
  white = 'white',
  green = '#94c768',
  greenDarker = '#2BAD00',
  red = '#C73A33',
  redDarker = '#C14446',
  grayLightest = '#fcfcfc',
  grayLight = '#f4f4f4',
  gray = '#888',
  grayDarker = '#555',
  grayDarkest = '#333',

  facebook = '#3b5998',
}

const theme = createTheme({
  spacing: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48],
  //        0  1  2   3   4   5   6   7   8   9

  palette: {
    primary: {
      main: Color.red,
    },
  },
});

export default theme;
